/**
 * @Relay no-runtime
 */
/**
 * @graphql cc
 */
import graphql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop';

import type {
	useCurrentUserContributorContentContributorsQuery as useCurrentUserContributorContentContributorsQuery$data,
	useCurrentUserContributorContentContributorsQueryVariables as useCurrentUserContributorContentContributorsQuery$variables,
} from './__types__/useCurrentUserContributorContentContributorsQuery';

const useCurrentUserContributorContentContributorsQuery = graphql`
	query useCurrentUserContributorContentContributorsQuery($contentId: ID!) {
		contentContributors(id: $contentId) {
			isCurrentUserContributor
		}
	}
`;

type CurrentUserContributorProperties = {
	isCurrentUserContributor?: boolean;
	contentContributorsLoading: boolean;
	contentContributorsError?: ApolloErrorInterop;
};

export const useCurrentUserContributor = (contentId: string): CurrentUserContributorProperties => {
	const {
		data,
		loading: contentContributorsLoading,
		error: contentContributorsError,
	} = useQuery<
		useCurrentUserContributorContentContributorsQuery$data,
		useCurrentUserContributorContentContributorsQuery$variables
	>(useCurrentUserContributorContentContributorsQuery, {
		variables: { contentId },
	});
	const isCurrentUserContributor: boolean | undefined =
		data?.contentContributors?.isCurrentUserContributor ?? undefined;

	return {
		isCurrentUserContributor,
		contentContributorsLoading,
		contentContributorsError,
	};
};
